import type { UnifiedQuestionRow } from './buildUnifiedRows';

/**
 * Select the 5 worst-offending FAIL questions for the Top Blockers card.
 *
 * Sort priority:
 *   1. More blockers > fewer blockers
 *   2. More warnings > fewer warnings
 *   3. Lower pipeline score > higher score
 */
export function selectTopBlockers(rows: UnifiedQuestionRow[], limit = 5): UnifiedQuestionRow[] {
  return [...rows].filter(r => r.verdict === 'FAIL').sort((a, b) => {
    if (b.blockerCount !== a.blockerCount) return b.blockerCount - a.blockerCount;
    if (b.warningCount !== a.warningCount) return b.warningCount - a.warningCount;
    return a.pipelineScore - b.pipelineScore;
  }).slice(0, limit);
}